<script>
export let backend;

let rioData = [];
let rioDataSize = 1;
let rioDataFetched = 0;
let requestProgress = 0;
let requestInProcess = false;
let csvUrl = "";
let csv = async function () {
    console.log("IN: " + csvUrl);
    if (csvUrl.length === 0) {
      return;
    }
    requestInProcess = true;
    let addRioData = function (rd) {
      rioData.push(rd);
    };
    let close = function () {
      requestInProcess = false;
    };
    backend.fetchWowOrderSuggestions(csvUrl)
      .then(d => {
        requestInProcess = false;
        rioData = d;
      })
      .catch((error) => {
        requestInProcess = false;
        console.error('Error:', error);
      });
};
function toCsv() {
  let csvContent = "data:text/csv;charset=utf-8,Order, Discord, email, armory, keys, rating\n" + rioData
    .map(o => o.order + ',' + o.discord + ',' + o.email + ',' + o.armory + ',' + o.keys + ',' + o.blizzardRating)
    .join("\n");
  let encodedUri = encodeURI(csvContent).replace(/#/g, '%23');
  let link = document.createElement("a");
  link.setAttribute("href", encodedUri);
  link.setAttribute("download", "rio-data.csv");
  document.body.appendChild(link); // Required for FF
  link.click();
}


</script>
<main>
<div id="app">
  <div class="input-group mb-3">
    <span class="input-group-text" id="basic-addon1">Google doc csv url</span>
    <input type="text" class="form-control" placeholder="url" aria-label="url" aria-describedby="basic-addon1" bind:value={csvUrl}>
  </div>
  <div>
    <button type="submit" class="btn btn-primary mb-3" on:click|preventDefault={csv}>Upload CSV</button>
  </div>
  <div>
    <button type="submit" class="btn btn-primary mb-3" on:click|preventDefault={toCsv}>Download CSV</button>
  </div>
  {#if requestInProcess}
  <div class="spinner-border text-light" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
  {/if}

  <table class="table table-sm table-dark table-striped">
    <thead>
    <tr>
      <th scope="col">#</th>
      <th scope="col">Order</th>
      <th scope="col">Discord</th>
      <th scope="col">Email</th>
      <th scope="col">Armory</th>
      <th scope="col">item</th>
      <th scope="col">Keys</th>
      <th scope="col">m+ rating</th>
    </tr>
    </thead>
    <tbody>
    {#each rioData as rio, index}
    <tr>
      <th scope="row">{index}</th>
      <td>{rio.order}</td>
      <td>{rio.discord}</td>
      <td>{rio.email}</td>
      <td><a href={rio.armory}>{rio.name}</a></td>
      <td>{rio.item}</td>
      <td class:table-success="{rio.keys == 0}"
          class:table-info="{rio.keys > 0 && rio.keys < 4}"
          class:table-warning="{rio.keys >= 4 && rio.keys < 10}"
          class:table-secondary="{rio.keys >= 10}" >
        {rio.keys}
      </td>
      <td
        class:table-success="{rio.blizzardRating < 2500}"
        class:table-secondary="{rio.blizzardRating >= 2500}"
        >
        {rio.blizzardRating}
      </td>
    </tr>
    {/each}
    </tbody>
  </table>
</div>
</main>